'use client'

import GeneralForm from "components/GeneralForm";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import { validate } from "components/validateGeneralForm";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Container } from "reactstrap";
import { erroInesperado } from "services/Utils";
import tipoComponenteService from "services/TipoComponenteService";

export default function FormTipoComponente() {
  const [data, setData] = useState({})
  const [edit, setEdit] = useState(false)
  const params = useParams()
  const navigate = useNavigate()

  const id = parseInt(params.id)
  const novo = (0 === id)

  useEffect(() => {
    if (!!id) {
      tipoComponenteService.getById(id).then(res => {
        if (res.success) {
          setData(res.data)
        }
      })
    } else {
      setData({})
    }
  }, [id])

  useEffect(() => {
    if (novo) {
      setEdit(true)
    }
  }, [novo])

  const formConfig = useMemo(() => {
    return [
      [
        { name: "descricao", label: 'Descrição', type: "text", required: true, colspan: 12 },
        { name: "quantidadeMaximaPorCruzamento", label: <>Quantidade máxima por cruzamento <small><i>- deixe em branco para não limitar</i></small></>, type: "integer", colspan: 5 },
        {
          name: "checkbox", type: "view", colspan: 4, component: (props) => {
            const { aceitaFilhos, exclusivoDeCruzamentoMestre } = data

            return (
              <div className="mt-4">
                <div className='d-flex flex-row align-items-center justify-content-start' style={{ gap: 10 }}>
                  <input
                    id="aceitaFilhos"
                    type="checkbox"
                    checked={aceitaFilhos}
                    onChange={e => props.onChange && props.onChange('aceitaFilhos', e.target.checked)}
                    className='ml-0'
                    disabled={props.formDisabled}
                  />
                  <label htmlFor="aceitaFilhos" className='mb-0'>Aceita filhos</label>
                </div>
                <div className='d-flex flex-row align-items-center justify-content-start' style={{ gap: 10 }}>
                  <input
                    id="exclusivoDeCruzamentoMestre"
                    type="checkbox"
                    checked={exclusivoDeCruzamentoMestre}
                    onChange={e => props.onChange && props.onChange('exclusivoDeCruzamentoMestre', e.target.checked)}
                    className='ml-0'
                    disabled={props.formDisabled}
                  />
                  <label htmlFor="exclusivoDeCruzamentoMestre" className='mb-0'>Exclusivo de cruzamento mestre</label>
                </div>
              </div>
            )
          }
        }
      ]
    ]
  }, [data])

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      if (novo) {
        await tipoComponenteService.create(data)
      } else {
        await tipoComponenteService.update(id, data)
      }
      toast('Registro salvo com sucesso!')
      navigate('/admin/tipos-componente')
    } catch (ex) {
      erroInesperado()
    }

  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Tipos de Componente" edit={edit} onChangeEdit={setEdit} showButton={!novo} />
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <GeneralForm
              config={formConfig}
              data={data}
              onChange={handleChange}
              disabled={!edit}
            />
            {edit && (
              <Button type="submit" color="primary">Salvar</Button>
            )}
          </form>
        </CardBody>
      </Card>
    </Container>
  )
}
